<template>
  <div
    id="variable-table">
    <table-component
      ref="variableTable"
      :data="fetchData"
      :showFilter="true"
      sort-by="id"
      sort-order="asc"
      :show-caption="false"
      class="datatable"
      filter-placeholder=""
      filterNoResults="">
      <table-column
        label=""
        header-class="table-component__minimum__width__column"
        :sortable="false"
        :filterable="false">
        <template slot-scope="row">
          <span
          v-tooltip.right.top-start="{
            content: displayCategoryInfo(row)
          }">
          <font-awesome-icon
            :id="row"
            :icon="icon.info"/>
          </span>
        </template>
      </table-column>
      <table-column
        show="name"
        :label="$t('variableManagement.name')"
        header-class="text-left"
        cell-class="table-component__text-left">
      </table-column>
      <table-column
        show="username"
        :label="$t('variableManagement.owner')"
        header-class="text-left"
        cell-class="table-component__medium__width__column">
      </table-column>
      <table-column
        label=""
        header-class="table-component__minimum__width__column"
        :sortable="false"
        :filterable="false">
        <template slot-scope="row">
          <font-awesome-icon
            v-on:click="onEditCategory(row)"
            :icon="icon.edit"
            class="table-iconset-icon clickable"/>
        </template>
      </table-column>
      <table-column
        label=""
        header-class="table-component__minimum__width__column"
        :sortable="false"
        :filterable="false">
        <template slot-scope="row">
          <font-awesome-icon
            v-on:click="onDeleteCategory(row)"
            :icon="icon.delete"
            class="table-iconset-icon clickable"/>
        </template>
      </table-column>
    </table-component>
  </div>
</template>

<script>
import TableColumn from '@/components/shared/table/components/TableColumn';
import TableComponent from '@/components/shared/table/components/TableComponent';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {
  faPencilAlt,
  faTrashAlt,
  faList
} from '@fortawesome/pro-regular-svg-icons';
import Tags from '@/components/variable/Tags';
import pagination from '@/components/shared/table/pagination';

export default {
  name: 'CategorizedVariableTable',
  components: {
    Tags,
    TableColumn,
    TableComponent,
    FontAwesomeIcon
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    variablesMinimal: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      icon: {
        edit: faPencilAlt,
        delete: faTrashAlt,
        info: faList
      },
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  watch: {
    data: {
      handler: function () {
        this.$refs.variableTable.refresh();
      }
    }
  },
  computed: {
    getVariablesMinimal () {
      return this.variablesMinimal;
    }
  },
  methods: {
    fetchData ({ page, filter, sort }) {
      const tablePage = pagination.createPage(
        this.data,
        this.tableState,
        ['name', 'username'],
        this.tablePageSize,
        { page, filter, sort });
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    onEditCategory (category) {
      this.$emit('onEdit', category);
    },
    onDeleteCategory (category) {
      this.$emit('onDelete', category);
    },
    displayCategoryInfo (category) {
      let rangesInfo = '<strong>' + this.$t('variables.variables') + '</strong>:</br>';
      this.getVariablesMinimal.filter(variable => category.variables.includes(variable.id)).forEach(variable => {
        rangesInfo += variable.label + '</br>';
      });
      rangesInfo += '</br><strong>' + this.$t('variableManagement.categories') + '</strong>:</br>';
      category.ranges.forEach(range => {
        rangesInfo += range.value + ': ' + range.name + '</br>';
      });
      return rangesInfo;
    }
  }
};
</script>

<style lang="scss">
  @import "../../stylesheets/variables.scss";

  .clickable {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/variable/CategorizedVariableTable.vue